import ChannelKey from '@avtechsoftware/ra-javascript-utilities/src/classes/ChannelKey';

export default class RaaChannelKey extends ChannelKey {
  constructor(channelKey = 'XX:XX:XX:XX:XX:XX_XX:XX:XX:XX:XX:XX_0_0_0_0') {
    super(channelKey);
    this.subscriptionId = parseInt(channelKey.split('_')[6], 10);
  }

  get fullChannelKey() {
    return `${this.macAddress}_${this.channelGroupMacAddress}_${this.channelGroupType}_${this.channelGroupIndex}_${this.channelType}_${this.channelIndex}_${this.subscriptionId}`;
  }
}
